/** @format */
import { Transition } from '@uirouter/core';
import { UniversityConfig } from 'common-typescript/types';
import * as _ from 'lodash-es';
import { ConfigService } from 'sis-common';

// redirects transitions to provided route when isTestModeEnabled = false
export const redirectIfTestModeIsDisabled = (fallbackRoute: string) => ($transition$: Transition) =>
    Promise.resolve($transition$.injector().get(ConfigService).get()).then((config: UniversityConfig) => {
        const isTestModeEnabled = _.get(config, 'isTestModeEnabled', false);
        if (isTestModeEnabled) {
            return;
        }
        return fallbackRoute;
    });
redirectIfTestModeIsDisabled.$inject = ['$transition$'];
